angular.module('unica_auth.auth_controllers')

.controller('ForgottenPasswordController', function(
	$rootScope, $scope, $state, ForgottenPasswordService
) {

	$scope.forgottenPasswordData = {};
	$scope.sendForgottenPasswordRequest = function() {
		$scope.showLoader();
		ForgottenPasswordService
			.forgottenPasswordRequest( $scope.forgottenPasswordData.fiscal_code, $scope.forgottenPasswordData.agency_code )
			.then(function( result ) {
				$scope.hideLoader();

				if ( result ) {
					$scope.showSuccessMsg('Richiesta recupero password effettuata con successo!', '');
					$state.go('app.auth_login');
				}

			});
	};

});